"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.destroyFns = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_dialog_1 = tslib_1.__importDefault(require("rc-dialog"));
var button_1 = tslib_1.__importDefault(require("../../button"));
var button_2 = require("../../button/button");
var config_provider_1 = require("../../config-provider");
var NormalClose_1 = require("../../Icons/NormalClose");
var useModal_1 = tslib_1.__importDefault(require("./useModal"));
var mousePosition;
exports.destroyFns = [];
var getClickPosition = function (e) {
    mousePosition = {
        x: e.pageX,
        y: e.pageY,
    };
    // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开
    setTimeout(function () {
        mousePosition = undefined;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
    document.documentElement.addEventListener('click', getClickPosition, true);
}
var Modal = function (props) {
    var _a;
    var _b = React.useContext(config_provider_1.ConfigContext), getContextPopupContainer = _b.getPopupContainer, getPrefixCls = _b.getPrefixCls, direction = _b.direction;
    var handleCancel = function (e) {
        var onCancel = props.onCancel;
        if (onCancel) {
            onCancel(e);
        }
    };
    var handleOk = function (e) {
        var onOk = props.onOk;
        if (onOk) {
            onOk(e);
        }
    };
    var renderFooter = function () {
        var _a = props.okText, okText = _a === void 0 ? '确定' : _a, okType = props.okType, _b = props.cancelText, cancelText = _b === void 0 ? '取消' : _b, confirmLoading = props.confirmLoading;
        return (React.createElement(React.Fragment, null,
            React.createElement(button_1.default, tslib_1.__assign({ onClick: handleCancel }, props.cancelButtonProps), cancelText),
            React.createElement(button_1.default, tslib_1.__assign({}, (0, button_2.convertLegacyProps)(okType), { loading: confirmLoading, onClick: handleOk }, props.okButtonProps), okText)));
    };
    var customizePrefixCls = props.prefixCls, footer = props.footer, visible = props.visible, wrapClassName = props.wrapClassName, centered = props.centered, getContainer = props.getContainer, closeIcon = props.closeIcon, _c = props.focusTriggerAfterClose, focusTriggerAfterClose = _c === void 0 ? true : _c, restProps = tslib_1.__rest(props, ["prefixCls", "footer", "visible", "wrapClassName", "centered", "getContainer", "closeIcon", "focusTriggerAfterClose"]);
    var prefixCls = getPrefixCls('modal', customizePrefixCls);
    var defaultFooter = React.createElement(React.Fragment, null, renderFooter());
    var closeIconToRender = (React.createElement("span", { className: "".concat(prefixCls, "-close-x") }, closeIcon || React.createElement(NormalClose_1.NormalClose, { className: "".concat(prefixCls, "-close-icon iconfont") })));
    var wrapClassNameExtended = (0, classnames_1.default)(wrapClassName, (_a = {},
        _a["".concat(prefixCls, "-centered")] = !!centered,
        _a["".concat(prefixCls, "-wrap-rtl")] = direction === 'rtl',
        _a));
    return (React.createElement(rc_dialog_1.default, tslib_1.__assign({}, restProps, { 
        // @ts-ignore
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer, prefixCls: prefixCls, wrapClassName: wrapClassNameExtended, footer: footer === undefined ? defaultFooter : footer, visible: visible, mousePosition: mousePosition, 
        // @ts-ignore
        onClose: handleCancel, closeIcon: closeIconToRender, focusTriggerAfterClose: focusTriggerAfterClose })));
};
Modal.useModal = useModal_1.default;
Modal.defaultProps = {
    width: 520,
    transitionName: 'zoom',
    maskTransitionName: 'fade',
    confirmLoading: false,
    visible: false,
    okType: 'primary',
    centered: true,
};
exports.default = Modal;
//# sourceMappingURL=Modal.js.map